import MenuAvailability from "./MenuAvailability";
import { MenuDeliverect } from "./MenuDeliverect";
import MenuSezione from "./MenuSezione";
import {Ristorante} from "./Ristorante";

export default class Menu {
    id!: number;
    deliverectId?: string;
    nome!: string;
    active!: boolean;
    sezioneList!: MenuSezione[];
    ristorante!: Ristorante;
    menuDeliverect?: MenuDeliverect;
    availabilities?: MenuAvailability[];

    static fromJson(json: any) {
        let result = new Menu();
        result.id = json.id;
        result.deliverectId = json.deliverectId;
        result.nome = json.nome;
        result.active = json.active;
        if (json.sezioneList) {
            result.sezioneList = json.sezioneList.map((sezione: any) => MenuSezione.fromJson(sezione));
        }
        if (json.ristorante) {
            result.ristorante = Ristorante.fromJson(json.ristorante);
        }

        if(json.menuDeliverect) {
            result.menuDeliverect = MenuDeliverect.fromJson(json.menuDeliverect);
        }
        
        if (json.availabilities) {
            result.availabilities = json.availabilities.map((avail: any) => MenuAvailability.fromJson(avail));
        }

        return result;
    }
}